import React, { Component, Fragment } from "react";
import ModalDecorator from "hocs/ModalDecorator";
import { $ } from "rype-bootstrap";
import { compose } from "redux";
import { connect } from "react-redux";

import ModalButton from "../../ModalButton/ModalButton";

import "../style.css";

class BeforeDeleteMembershipModal extends Component {
  constructor() {
    super();

    $.noConflict();
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $("#before-delete-ms-modal").modal("show"), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $("#before-delete-ms-modal").on("hidden.bs.modal", () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $("#before-delete-ms-modal").modal("hide");
  };

  handleChange = (value) => {
    this.setState({ selectedPeriod: value });
  };

  render() {
    const currentPlan = this.props.user.stripePlan;
    const isPausable = currentPlan.cycle.split("_")[0] !== "prepaid";

    return (
      <div
        id="before-delete-ms-modal"
        className="DeleteMembershipModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="delete-membership-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src="/assets/delete.png" alt="delete" className="mb-3" />
              <h5>Before you delete...</h5>
              <iframe
                title="delete-membership"
                width="400"
                height="225"
                src="https://www.youtube.com/embed/OtFB296sf7s?controls=0"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
              <h6 className="mt-4">By deleting your membership:</h6>
              <ul className="list-group list-group-flush mt-3">
                <li className="list-group-item">
                  <img src="/assets/delete.png" alt="delete" className="mr-4" />
                  My scheduled lessons will be deleted
                </li>
                <li className="list-group-item">
                  <img src="/assets/delete.png" alt="delete" className="mr-4" />
                  I&#39;ll lose access to 1-on-1 lessons
                </li>
                <li className="list-group-item">
                  <img src="/assets/delete.png" alt="delete" className="mr-4" />
                  I&#39;ll lose access to Rype&#39;s all-access language pass
                </li>
                <li className="list-group-item">
                  <img src="/assets/delete.png" alt="delete" className="mr-4" />
                  I&#39;ll lose access to Rype&#39;s handpicked teachers
                </li>
              </ul>
              {isPausable && (
                <Fragment>
                  <div className="small-tip font-italic mt-3">
                    We highly recommend pausing your membership instead to
                    <br />
                    retain these benefits.
                  </div>
                  <ModalButton
                    className="btn btn-primary btn-cursor btn-gray mt-4"
                    modalId="pause-membership-modal"
                  >
                    Pause membership
                  </ModalButton>
                </Fragment>
              )}
              <div className="mt-4 mailto">
                <a
                  href="https://rype.typeform.com/to/wXKBlA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Continue deleting my membership
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
  };
}

export default compose(
  ModalDecorator("before-delete-ms-modal"),
  connect(mapStateToProps)
)(BeforeDeleteMembershipModal);



// WEBPACK FOOTER //
// ./src/components/modals/DeleteMembershipModals/Before/index.js